import { Component, OnInit } from '@angular/core';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { vignetteOpePit } from 'src/app/models/vignetteOpePit';
import { PituploadService } from 'src/app/services/pitupload/pitupload.service';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pitupload-galerie',
  templateUrl: './pitupload-galerie.component.html',
  imports: [ProgressBarModule,ButtonModule,FormsModule,ToastModule,DialogModule,ConfirmDialogModule,CommonModule,ButtonModule],
  styleUrls: ['./pitupload-galerie.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class PituploadGalerieComponent implements OnInit {

  previewUrl: string | ArrayBuffer | null = null;
  uploadVigDialog = false;
  titlepopupUpload = "";
  images: vignetteOpePit[] = [];
  imagesFiltre: vignetteOpePit[] = this.images.filter(item => item.position != 1);
  blobImageToUpload = "";
  fileUploader!: File;
  editElementImage: any;



  constructor(public pitService: PituploadService, private sharePitSevices: sharePitSevices, private confirmationService: ConfirmationService, private messageService: MessageService, public share: shareOpeSevices) { }

  ngOnInit() {
    this.sharePitSevices.mediaArrayPit$.subscribe(data => {
      this.images = data;
      this.imagesFiltre = this.images.filter(item => item.position != 1);
    });
  }

  editGalItem(element: any) {
    this.titlepopupUpload = "Modifier l'image";
    this.uploadVigDialog = true;
    this.editElementImage = element;
    this.previewUrl = null;
  }

  deleteGalItem(element: vignetteOpePit) {
    let objDel = structuredClone(element);
    delete objDel.showActions;
    delete objDel.imageLoaded;
    objDel.eiBinPit.bblob = "";
    objDel.user = this.sharePitSevices.user!;
    this.share.showprogressbar = true;
    this.pitService.deleteMedia(objDel).subscribe(res => {
      this.messageService.add({ severity: "success", summary: "Galerie photos ", detail: "suppression avec succès" });
      this.images = this.images.filter(item => item !== element);
      for (let index = 0; index < this.images.length; index++) {
        this.images[index].position = index + 1;
      }
      this.sharePitSevices.sendMediaArrayPit(this.images);
      this.share.showprogressbar = false;
      /*this.pitService.getFirVignetteBynumOpe(element.numOpe).subscribe(res => {
        this.share.showprogressbar = false;
        this.sharePitSevices.sendMediaArrayPit(res);
      })*/
    },
      error => {
        this.share.showprogressbar = false;
        // console.log(error);
      })
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.handleFile(file);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    if (file && file.type.startsWith('image/')) {
      this.fileUploader = file;
      const reader = new FileReader();
      reader.onload = async (e) => {
        this.previewUrl = reader.result;
      }
      reader.readAsDataURL(file);

      // send to backend 
      // this.messageService.add({ severity: 'success', summary: "Upload", detail: "Publication Web désactivée" });
    } else {
      this.messageService.add({ severity: 'error', summary: "Le fichier n'est pas accepté ", detail: file.type });
    }
  }

  addImage() {
    // TODO : add image
    this.titlepopupUpload = "Ajouter une image";
    this.uploadVigDialog = true;
    this.previewUrl = null;
    this.editElementImage = null;
  }

  confirm2(element: any) {
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Valider la suppression ?',
      acceptLabel: 'Oui',
      accept: () => {
        //this.messageService.add({ severity: 'success', summary : "Suppression", detail: "Le document est supprimé avec succès" });
        this.deleteGalItem(element);
      },
      rejectLabel: 'Non'
    });
  }

  annulerUploadVig() {
    this.uploadVigDialog = false;
    this.previewUrl = null;
    this.editElementImage = null;
  }

  luanchUploadVig() {
    this.share.showprogressbar = true;
    this.blobImageToUpload = (this.previewUrl as string).split(',')[1];
    let objectCreate = this.getObjectVigFirst();
    this.pitService.updateMedia(objectCreate).subscribe({
      next: (res) => {
        this.pitService.getFirVignetteBynumOpe(objectCreate.numOpe).subscribe({
          next: (res) => {
            this.messageService.add({ severity: "success", summary: "Galerie photos ", detail: "Modification avec succès" });
            this.share.showprogressbar = false;
            this.sharePitSevices.sendMediaArrayPit(res);
            this.uploadVigDialog = false;
            this.editElementImage = null;
          },
          error: (err) => {
            this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
            this.share.showprogressbar = false;
          }
        })
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
        this.share.showprogressbar = false;
      },
    });
  }


  getObjectVigFirst() {
    let objUpdate: any;
    if (this.editElementImage) {
      objUpdate = structuredClone(this.editElementImage);
      objUpdate.eiBinPit.btype = this.fileUploader.type.split('/')[1];
      objUpdate.eiBinPit.bblob = this.blobImageToUpload;
      objUpdate.eiBinPit.btaille = this.fileUploader.size;
      objUpdate.eiBinPit.bnom = this.fileUploader.name;
      objUpdate.dm = new Date;
    } else {
      objUpdate = {
        code: null,
        eiBinPit: {
          btype: this.fileUploader.type.split('/')[1],
          bblob: this.blobImageToUpload,
          btaille: this.fileUploader.size,
          bnom: this.fileUploader.name,
          bcode: null
        },
        numOpe: this.sharePitSevices.pituploadSelectedOpe.numOpe,
        langue: 'FR',
        urlDoc: this.fileUploader.name,
        urlImage: this.fileUploader.name,
        commentaire: "",
        typeDoc: 146,
        position: this.imagesFiltre.length + 2,
        dc: new Date,
        dm: new Date,
        user: this.sharePitSevices.user,
        nomFichier: this.fileUploader.name
      }
    }
    return objUpdate;
  }

}